import * as yup from 'yup';

const SkillsSchema = () =>
  yup.object().shape({
    skills: yup.array(),
  });

export default SkillsSchema;
